export default {
	addressTile: {
		deliveryNotificationPhone: "Avis de livraison : {phone}",
		invoiceSentVia: "La facture est envoyée par {method}",
		invoiceMethodEmail: "E-mail",
		invoiceMethodPost: "Courrier",
		applyAddressButton: "Utiliser",
		preferredTooltipAlreadySet:
			"Cette adresse est déjà marquée comme favorite et sera présélectionnée pour vos commandes.",
		preferredTooltipSetAsFavorite:
			"Définir comme favorite. Cette adresse sera présélectionnée pour vos commandes.",
		editAddressTooltip: "Modifier l'adresse",
		editPermissionMissingTooltip: "Autorisation de modifier l'adresse non accordée",
		deleteAddressTooltip: "Supprimer l'adresse",
		deletePermissionMissingTooltip: "Autorisation de supprimer l'adresse non accordée",
		deleteAddressDialog: {
			title: "Supprimer l'adresse",
			text: "Êtes-vous sûr de vouloir supprimer cette adresse ?",
			deleteButtonTooltip: "Supprime définitivement l'adresse.",
			deleteButton: "Supprimer",
		},
	},
	addressesOverview: {
		createAddressButton: "Créer une nouvelle adresse",
	},
	changeAddress: {
		newAddressTitle: "Créer une nouvelle adresse",
		editAddressTitle: "Modifier l'adresse",
		firstNameLabel: "Prénom",
		lastNameLabel: "Nom",
		companyLabel: "Entreprise",
		streetLabel: "Rue / N°",
		zipLabel: "NPA",
		townLabel: "Localité",
		countryHint: "Le pays ne peut pas être modifié. Veuillez nous contacter à info@blexon.com",
		deliveryPhoneLabel: "Numéro de téléphone pour l'avis de livraison",
		invoiceEmailLabel: "Adresse e-mail pour l'envoi de la facture",
		invoiceByEmailLabel: "Facture par e-mail",
		invoiceByPostLabel: "Facture par courrier",
		shippingMethodLockedText: "Le mode d'envoi ne peut plus être modifié pour cette commande.",
		saveButtonTooltip: "Enregistre les modifications.",
		invalidZipMessage: "Doit être un NPA valide.",
		messages: {
			saveSuccess: "Adresse enregistrée avec succès.",
			saveError: "L'adresse n'a pas pu être enregistrée.",
		},
	},
	customerSettings: {
		customerNumberLabel: "Votre numéro de client",
		customerNumberHint: "Ce numéro est attribué de manière fixe et ne peut pas être modifié.",
		personalAccountLabel: "Compte personnel / privé",
		companyNameLabel: "Nom de l'entreprise",
		vatNumberLabel: "Numéro de TVA / N° d'identification TVA",
		useCompanyAccountLabel: "Utiliser comme compte d'entreprise",
		streetLabel: "Rue / N°",
		zipLabel: "NPA",
		townLabel: "Localité",
		countryLabel: "Pays",
		generalPhoneLabel: "Téléphone (général)",
		accountEmailLabel: "E-mail du compte client",
		accountEmailHint: "Cette adresse est utilisée comme alternative à l'e-mail de l'utilisateur.",
		defaultOrderNotificationEmailLabel:
			"E-mail standard pour les notifications de commande supplémentaires",
		defaultOrderNotificationEmailHint:
			"Lors du processus de commande, une adresse e‑mail supplémentaire peut être indiquée, qui sera également informée de la commande. Si une adresse e‑mail est indiquée dans le champ ci-dessus, celle-ci sert d'adresse par défaut et est automatiquement complétée.",
		correspondenceLanguageLabel: "Langue de correspondance",
		correspondenceLanguageHint:
			"C'est la langue dans laquelle sont établis tous les documents tels que les confirmations de commande et les factures, ainsi que tous les e‑mails qui vous sont adressés.",
		requiredMessage: "Indication requise",
		whitespaceOnlyMessage: "La saisie ne peut pas contenir uniquement des espaces.",
		maxLength50Message: "50 caractères maximum autorisés.",
		companyNamePrivateMessage: "Le nom de l'entreprise ne peut pas être 'privat'.",
		invalidZipMessage: "Doit être un NPA valide.",
		messages: {
			saveSuccess: "Paramètres enregistrés avec succès.",
			saveError: "Les paramètres n'ont pas pu être enregistrés.",
		},
	},
	userManagement: {
		addUserButton: "Ajouter un utilisateur",
		emailChangeHint:
			"Remarque : pour modifier l'adresse e-mail de l'utilisateur actuel, veuillez utiliser la fonction dans les {userSettingsLink}.",
		userSettingsLinkText: "paramètres utilisateur",
		pendingConfirmationTooltip: "Confirmation de l'utilisateur invité encore en attente.",
		contextMenuTooltip: "Ouvre le menu contextuel de l'utilisateur.",
		deleteMenuItem: "Supprimer",
		manageUsersLabel: "Gérer les utilisateurs",
		orderDirectlyLabel: "Commander",
		orderIndirectlyLabel: "Demander une commande",
		changeDeliveryAddressLabel: "Modifier les adresses de livraison",
		changeInvoiceAddressLabel: "Modifier les adresses de facturation",
		ownUserRightsTooltip: "Les droits de votre propre utilisateur ne peuvent pas être modifiés.",
		unconfirmedUserRightsTooltip:
			"Les droits ne peuvent être modifiés que lorsque l'utilisateur est confirmé.",
		manageUsersMinimumTooltip:
			"Au moins 1 utilisateur doit toujours disposer du droit « Gérer les utilisateurs ».",
		manageUsersDescriptionTooltip:
			"L'utilisateur peut ajouter d'autres utilisateurs, supprimer des utilisateurs et modifier les droits de tous les utilisateurs.",
		orderDirectlyMinimumTooltip:
			"Au moins 1 utilisateur doit toujours disposer du droit « Commander ».",
		orderDirectlyDescriptionTooltip: "L'utilisateur peut passer des commandes payantes.",
		orderIndirectlyDescriptionTooltip:
			"L'utilisateur peut préparer des commandes et les envoyer pour confirmation à un utilisateur disposant de l'autorisation correspondante.",
		changeDeliveryAddressDescriptionTooltip: "L'utilisateur peut modifier les adresses de livraison.",
		changeInvoiceAddressDescriptionTooltip:
			"L'utilisateur peut modifier les adresses de facturation.",
		noPermissionText: "Autorisation de gestion des utilisateurs non accordée.",
		addUserDialogTitle: "Ajouter un utilisateur",
		newUserEmailPlaceholder: "E-mail du nouvel utilisateur",
		newUserRightsLabel: "Droits du nouvel utilisateur",
		addButton: "Ajouter",
		deleteUserDialog: {
			title: "Êtes-vous sûr ?",
			text: "Voulez-vous vraiment retirer l'utilisateur {username} de ce compte ?",
			confirmButton: "Retirer",
		},
		messages: {
			loadUserIdError: "Erreur lors du chargement de l'identifiant de l'utilisateur.",
			loadUsersError: "Erreur lors du chargement des utilisateurs.",
			saveClaimSuccess: "Autorisation enregistrée avec succès.",
			saveClaimError: "Erreur lors de l'enregistrement de l'autorisation.",
			inviteSuccess: "Invitation envoyée avec succès à l'utilisateur.",
			inviteError: "Erreur lors de l'envoi de l'invitation à l'utilisateur.",
			removeUserError: "Erreur lors de la suppression de l'utilisateur.",
		},
	},
};
